import { api, uninterceptedApi } from "@/lib/api";
import { LoginOrganization, MePermissionsResponse } from "@/lib/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export interface ValidateResetTokenRequest {
  token: string;
}

export interface ValidateResetTokenResponse {
  valid: boolean;
}

type AuthQueryOptions<T> = Omit<
  UseQueryOptions<T, Error, T>,
  "queryKey" | "queryFn"
>;

export const useValidateResetToken = (
  data: ValidateResetTokenRequest,
  options?: AuthQueryOptions<ValidateResetTokenResponse>
) => {
  return useQuery<ValidateResetTokenResponse>({
    queryKey: ["validate-reset-token", data.token],
    queryFn: async () => {
      const response = await uninterceptedApi.get<ValidateResetTokenResponse>(
        `/auth/validate-reset-token?token=${data.token}`
      );
      return response.data;
    },
    enabled: !!data.token,
    ...options,
  });
};

export const useGetMe = (options?: AuthQueryOptions<MePermissionsResponse>) => {
  return useQuery<MePermissionsResponse>({
    queryKey: ["me"],
    queryFn: async () => {
      const response = await api.get<MePermissionsResponse>("/me");
      return response.data;
    },
    ...options,
  });
};

export async function getMyOrganizations(): Promise<LoginOrganization[]> {
  const response = await api.get<LoginOrganization[]>("/auth/organizations");
  return response.data;
}
